import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styles from '../styles/AppLoadingScreen.module.css';

const AppLoadingScreen = () => (
  <div className={styles.screen} role="status" aria-live="polite" aria-label="Loading application">
    <img
      src={`${process.env.PUBLIC_URL}/brand/lotw-mark.png`}
      alt=""
      className={styles.logo}
      aria-hidden="true"
    />
    <div className={styles.wordmark}>LOTW League</div>
    <div className={styles.subtitle}>Lock of the Week</div>
    <div className={styles.divider} aria-hidden="true" />
    <CircularProgress size={36} thickness={4} className={styles.spinner} />
  </div>
);

export default AppLoadingScreen;
